
import styled from "styled-components";
import {media} from '@prima-afp/prima-ui-design-system/dist/media';

export const ContainerHeader = styled.div`
    display: flex;
    min-width: 636px;
    max-width: 720px;
    margin: 0 auto;
    padding: 40px 0px;
    height: 20px;    
    justify-content: space-between;
    align-items: center;
    .text{
    color: var(--Primary-Orange-Prima, #ff4f00);
            text-align: center;
            max-width: 125px;
            font: 700 16px/125% Calibri, -apple-system, Roboto, Helvetica, sans-serif;
    }
    #btn-identity-back{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    ${media.xs} {
        min-width: 100%;
        width: 100%;
        margin: 0px;
        padding: 0px 16px;
        height: 64px;
        box-shadow: 2px 2px 10px 2px rgba(235, 235, 235, 1);
        align-items: center;
        display: none;
    }

    ${media.sm} {
        min-width: 100%;
        width: 100%;
        margin: 0px;
        padding: 0px 32px;
        height: 64px;
        box-shadow: 2px 2px 10px 2px rgba(235, 235, 235, 1);
        align-items: center;
        display: none;
    }

    ${media.md}{
        max-width: none;
    }

    .primaLogoStep0{
        aspect-ratio: 5.26;
        object-fit: auto;
        object-position: center;
        width: 94px;
        fill: var(--Primary-Orange-Prima, #ff4f00);
        align-self: start;
    }


`


export const ContainerTitleAMP = styled.div`
    max-width: 648px;
    padding-top:8px;
    .title{
        font-family: Lexend;
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0.12%;
        font-variant-numeric-figure: lining-nums;
        font-variant-numeric-spacing: proportional-nums;
        color: var(--Text-Primary-Default, rgba(255, 79, 0, 1));
        padding-bottom: 24px;
    }
    .subtitleAMP{
        max-width: 641px;
        font-family: Calibri;
        font-weight: 400;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0.12%;
        color: var(--Text-Gray-Default, rgba(78, 82, 88, 1));
    }
    ${media.xs}{
        max-width: 312px;
        padding-bottom: 16px;
        .title{
            padding-bottom: 8px;
        }
        .subtitleAMP{
        }
            
    }
    
`

const _buttonMobile = `
    display: grid;
    grid-template-rows: repeat(1, 1fr);
    justify-content: normal;

    button:last-child {
        width: 100%;
        order: -1;
        height: 48px;
        margin-bottom: 1rem;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100% !important;
  

    .newUiBtn{
        justify-content: center;
        border-radius: var(--Radius-Radius-16, 16px);
        white-space: nowrap;
        text-align: center;
        letter-spacing: 0.02px;
        padding: 16px 20px;
        font: 400 18px / 133% Lexend, -apple-system, Roboto, Helvetica, sans-serif;
        height: 56px;
    }

    .disabledBtn{
          border-radius: var(--Radius-Radius-16, 16px);
          background-color: var(--Background-Disabled-Subtle, #e7e7e8);
          color: var(--Text-Disable-Disabled, #84878b);
    }
    .enabledBtn{
        background-color: var(--orangeColorMain);
        color: #FFFFFF;
    }
    ${media.xs}{
        ${_buttonMobile}
        margin-top: 40px  !important;
        margin-bottom: 10px !important;
        flex-direction: column !important;
        align-items: center;
        display:flex;
        #identity-btn-env{
            width: 93vw !important;
            margin-bottom: 0px !important;
        }
        .buttonStep1{
            width: 312px !important;
            margin-bottom: 0px !important;
        }
        #identity-btn-env-12{
            width: 312px;
        }
        .newUiBtn{
            width: 200px;
        }

        #identity-btn-env{
            margin-top: 40px;
            margin-bottom: 40px;
        }
    }

    ${media.sm} {
        ${_buttonMobile}
        margin-top: 48px !important;
        margin-bottom: 152px !important;
        width: 704px !important;
        display: flex !important;
        flex-direction: row !important;
        --justify-content: flex-end !important;
        justify-content: center;
        .newUiBtn{
            width: 200px;
        }
    }

    ${media.md} {
        #identity-btn-env{
            margin-top: 40px;
            margin-bottom: 40px;
            width:142px;
            height: 40px;
        }
        .newUiBtn{
            width: 200px;
        }
    }
    
    ${media.lg} {
        margin-top: 48px !important;
        margin-bottom: 64px;
        .newUiBtn{
            width: 200px;
        }
    }

`;

export const ContainerContactData = styled.div`
    input, select {
        max-width: 100%;
    }

    ${media.xs}{ { 
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        margin-top: 32px;
        width: 90vw;
        .wrapperInputs{
            width: 312px !important;
            flex-wrap: wrap !important;
            margin-bottom: 0px !important;
            margin-top: 0px !important;
            height: auto !important;
        }
        #idStep1ContainerInputs{
            width: 95%;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
        }        
    }

    ${media.md} {            
        #idStep1ContainerInputs{
            width: 100%;
            margin-bottom: 53px;
        } 
    }

     ${media.lg} {            
        #idStep1ContainerInputs{
            width: 100%;
            margin-bottom: 53px;
        }  
    }
`;
